/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/prop-types */
import NextImage from 'next/image';
import useMounted from 'hooks/useMounted';

const Image = ({ src, ...props }) => {
  const isMounted = useMounted();
  if (isMounted) {
    return <NextImage src={src} {...props} />;
  }

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      src={`/blog/_next/image/?url=${encodeURIComponent(src)}&w=1280&q=75`}
      {...props}
      loading="lazy"
    />
  );
};

export default Image;
